<template>
  <div>
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-form @submit.prevent="fetchFraudTrips">
          <b-container fluid>
            <b-row class="mb-2">
              <b-col md="4">
                <label for="user">Search by user phone number</label>
                <b-form-input
                  id="user"
                  v-model="queryParams.user_phone"
                  type="number"
                  placeholder="User Phone Number"
                />
              </b-col>
              <b-col md="4">
                <label for="driver">Search by driver phone number</label>
                <b-form-input
                  id="driver"
                  v-model="queryParams.driver_phone"
                  type="number"
                  placeholder="Driver Phone Number"
                />
              </b-col>
              <b-col md="4" />
              <b-col
                md="4"
                class="mt-1"
              >
                <label for="tripId">Search by trip id</label>
                <b-form-input
                  id="tripId"
                  v-model="queryParams.trip_id"
                  placeholder="Trip Id"
                />
              </b-col>
              <b-col
                md="4"
                class="mt-1"
              >
                <label for="tripExternalId">Search by trip external id</label>
                <b-form-input
                  id="tripExternalId"
                  v-model="queryParams.trip_external_id"
                  placeholder="Trip External Id"
                />
              </b-col>
              <b-col
                md="4"
                class="mt-1"
              >
                <div class="mt-2 d-flex justify-content-between align-items-center">
                  <b-button
                    variant="primary"
                    type="submit"
                  >
                    Search
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    @click="clearFilter"
                  >
                    Clear
                  </b-button>
                  <b-button
                    class="btn-icon rounded-circle"
                    variant="flat-primary"
                    type="submit"
                  >
                    <feather-icon
                      icon="RefreshCwIcon"
                    />
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-container>

        </b-form>
        <b-table
          :fields="tableColumns"
          :items="fraudTrips"
          responsive
          class="text-center"
          show-empty
          empty-text="No matching data found"
          :per-page="perPage"
          :current-page="page"
          hover
          @row-clicked="pushToTripDetails"
        />
        <base-pagination
          v-model="page"
          :total="total"
          @new-per-page="perPage = $event"
        />

      </b-overlay>
    </b-card>

  </div>
</template>

<script>import {
  BCard, BTable, BOverlay, BForm, BContainer, BRow, BCol, BFormInput, BButton,
} from 'bootstrap-vue'
import useFraudTrips from '../hooks/useFraudTrips'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import fraudTripsStore from '../store'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BCard, BTable, BasePagination, BOverlay, BForm, BContainer, BRow, BCol, BFormInput, BButton,
  },
  setup(_, ctx) {
    useRegisterStoreModule('fraud', fraudTripsStore)
    return {
      ...useFraudTrips(ctx),
    }
  },
}
</script>

<style>

</style>
